import actionTypes from "utils/redux/actions/actionTypes";

 


const initialState = {
    productList: [], 
    isLoading: false,
    hasError: false,
    errorMessage: "", 
};
export function productReducer(state = initialState, action) {

    switch (action.type) {
        case actionTypes.SELECT_PRODUCT_LIST_SUCCESS:

            return {
                ...state,
                productList : action.payload
            };

        case actionTypes.SELECT_PRODUCT_LIST_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            };
  
        case actionTypes.SELECT_PRODUCT_LIST_ERROR:
            return {
                ...state,
                hasError: action.hasError,
                errorMessage: action.errorMessage
            }; 
        default:
            return state;
    }
}
